import React from 'react';

const AuthenticationTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'login', label: 'Login' },
    { id: 'signup', label: 'Sign Up' }
  ];

  return (
    <div className="flex bg-muted rounded-lg p-1 mb-8">
      {tabs?.map((tab) => (
        <button
          key={tab?.id}
          onClick={() => onTabChange(tab?.id)}
          className={`flex-1 py-2 px-4 text-sm font-medium rounded-md transition-smooth ${
            activeTab === tab?.id
              ? 'bg-surface text-text-primary shadow-soft'
              : 'text-text-secondary hover:text-text-primary'
          }`}
        >
          {tab?.label}
        </button>
      ))}
    </div>
  );
};

export default AuthenticationTabs;